import {  TimelineMax } from "gsap";
import { IDimConfig, ResizeHelper } from "@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { SplashView } from "../SplashController"
import { TextStyleOptions } from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { SanEngineManager } from "../../../../engine/SanEngineManager";
import { PostCounter } from "../../poster/PostCounter";
import {  SpinePlayer } from "../../../../proto/SpinePlayer";

export interface SplashViewResultData{
    fs:number;
    jw:number;
}

export class SplashViewResult extends BaseView implements SplashView {

    private _jw_spine:SpinePlayer;

    private _timeLine: TimelineMax;

    protected layoutDim: IDimConfig = {
        dimOrientation: {
            landscape: {
                scale: new PIXI.Point(1, 1),
                position: new PIXI.Point(360, 300),
                layout: {
                    left: new PIXI.Point(360, 300),
                    right: new PIXI.Point(360, 300)
                }
            },
            portrait: {
                scale: new PIXI.Point(1.1, 1.1),
                position: new PIXI.Point(360, 300)
            }
        },
        WIDTH: 240,
        HEIGHT: 64,
    };

    constructor(textStyle: TextStyleOptions) {
        super();
        this.visible = false;
    }

    protected initAnimations(): void {
    }
  
    public play(): TimelineMax {
        this._timeLine = Helper.timeLineKiller(this._timeLine, new TimelineMax({ onStart: () => this.visible = true }));
        this._timeLine.to(this,0.5,{})
        this._timeLine.add(() => PostCounter.instance.playEnd());
        return this._timeLine;
    }

    public stop(): TimelineMax {
        this._timeLine = Helper.timeLineKiller(this._timeLine, new TimelineMax({ onComplete: () => { this.visible = false; this._jw_spine.stop();}}));
        this._timeLine.to(this, 0.35, { alpha: 0 },0);
        return this._timeLine;
    }

    public onResize(): void {
        if (this._timeLine && this._timeLine.isActive()) this._timeLine.progress(1);

        const isLand: boolean = ResizeHelper.IsLandscape();
        this.scale = SanEngineManager.dim.scale;
    }
}
